<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pa-3">
        <orden-compra-crud />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OrdenCompraCrud from "./OrdenCompraCrud/OrdenCompraCrud.vue";

export default {
  name: "OrdenCompraManagementPage",
  components: { OrdenCompraCrud },
};
</script>
